<template>
  <div class="btn-group bootstrap-select dropdown">
    <button
        :class="'btn dropdown-toggle btn-default period-dropdown ' + classProps"
        type="button"
        :id="'dropdownMenuButton' + classProps"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
    >
      <span>{{ translate === false ? defaultTitle : $t(defaultTitle) }}</span>
    </button>
    <div class="dropdown-parent dropdown-menu dropdown-item-custom" :aria-labelledby="'dropdownMenuButton' + classProps">
      <a v-if="allowAll" class="dropdown-item" :key="ALL_VALUE.key" href="#" @click="handleClick(ALL_VALUE)">
        <span>{{ $t(ALL_VALUE.value) }}</span>
      </a>
      <a class="dropdown-item" href="#" v-for="item in items" :key="item.key" @click="handleClick(item)">
        <span>{{ translate === false ? item.value : $t(item.value) }}</span>
      </a>
    </div>
  </div>
</template>

<script>
/**
 * @author HungNS
 */
import $ from "jquery";

export default {
  name: "DropdownSelect",
  data: function () {
    return {
      ALL_VALUE: {
        key: -1,
        value: 'default.combo.box',
      }
    };
  },
  props: {
    items: {
      type: Array
    },
    classProps: {
      type: String,
      require: true
    },
    translate: {
      type: Boolean
    },
    allowAll: {
      type: Boolean
    }
  },
  methods: {
    handleClick(item) {
      $("#dropdownMenuButton" + this.classProps).text(this.$i18n.t(item.value));
      this.$emit("onSelect", item.key);
    },
  },
  computed: {
    defaultTitle: function () {
      if (this.allowAll) {
        return 'default.combo.box';
      }
      let value = "";
      if (this.items.length > 0) {
        let tempArr = this.items.filter((item) => item.default);
        if (tempArr.length == 0) {
          value = this.items[0].value;
        } else {
          value = tempArr[0].value;
        }
      }
      return value;
    },
  },
};
</script>

<style scoped>
.btn {
  border-radius: 3px;
  border: 1px solid #ddd;
  background: transparent;
  font-size: 14px;
}

.btn-label {
  overflow: hidden;
  width: 100% !important;
  text-align: left;
}

.dropdown-parent {
  width: 100%;
}
.HistoryType {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.DepositStatus {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.TransferStatus {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.period-dropdown{
  min-width: 110px;
}
.dropdown-item-custom{
  min-width: 110px;
}

.btn:focus{
  outline: 5px auto -webkit-focus-ring-color!important;
  outline-offset: -2px;
}
  
</style>
